/**
 * Defines a possible building placements relative to the other building.
 */
export enum BuildingPlacement {
    Detached = 'DETACHED',
    Middle = 'MIDDLE',
    Corner = 'CORNER'
}
